import React from 'react';
import { differentiators } from '../data/hvac';
export function DifferentiatorSection() {
  return <section className="bg-off px-4 py-5 sm:py-7" data-id="element-32" data-mp="3j4h0vpvumb5d">
      <div className="mx-auto max-w-4xl" data-id="element-33" data-mp="3j24jpexx04td">
        <h2 className="text-center text-xl leading-tight text-navy sm:text-3xl" data-id="element-34" data-mp="354z9r3v2ylsu">
          This isn’t just another HVAC ebook
        </h2>
        <p className="mt-1 text-center font-display text-lg uppercase text-hvac sm:text-2xl" data-id="element-35" data-mp="3a1zg7fvudqkh">
          It’s a complete visual diagnostic system.
        </p>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2 lg:grid-cols-3" data-id="element-36" data-mp="305w9dwq1p3r7">
          {differentiators.map(item => <li key={item.title} className="rounded-lg border border-navy/10 bg-white p-3 shadow-sm" data-id="element-37" data-mp="2mezl2i35j8py">
              <p className="text-sm font-extrabold uppercase leading-tight text-navy" data-id="element-38" data-mp="2qd73dhd9ki39">
                <span aria-hidden="true" data-id="element-39" data-mp="2chv9fc6xmvne">{item.emoji}</span> {item.title}
              </p>
              <p className="mt-1 text-sm font-medium leading-snug text-charcoal/80" data-id="element-40" data-mp="2he3jib69vynp">
                {item.body}
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}